import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IAppSummaryStatisticsVm } from '../app-summary-statistics-vm.model';
@Injectable({ providedIn: 'root' })
export class AppSummaryStatisticsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/AppSummaryStatistics`;
  }
  get(): Observable<IAppSummaryStatisticsVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    return this.http.get<IAppSummaryStatisticsVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
